import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLoad } from "./shared";

export const ClientSelect = ({ call, value, onChange, disabled, testid = "client-select" }) => {
  const { data } = useLoad(call, "/clients");
  const clients = data?.clients || [];
  return (
    <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Select a client" /></SelectTrigger>
      <SelectContent>
        {clients.map(c => (
          <SelectItem key={c.client_id} value={c.client_id}>{c.name}{c.company ? ` (${c.company})` : ""} — {c.email}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
